module.exports = __webpack_public_path__ + "img/hic-external-causes-female.86c23e2d.png";